module.exports = __webpack_public_path__ + "img/check_circle.951edf65.svg";